/* eslint-disable max-len */
/**
 * Awvent - Awvent Users API
 * Awvent User Apis
 *
 * OpenAPI spec version: v1
 * Contact: djoyrocks@gmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

 import {
    HttpClient,
    HttpEvent,
    HttpHeaders, HttpParams,
    HttpResponse
} from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';

 import { Observable } from 'rxjs';
 import { environment } from '../../../../../environments/environment';

 import { BooleanWebApiResponse } from '../../../common/models/booleanWebApiResponse';
import { GuestUserCreateCommand } from '../model/guestUserCreateCommand';
import { UserCreateCommand } from '../model/userCreateCommand';
import { UserDisableCommand } from '../model/userDisableCommand';
import { InvitationStateDtoWebApiResponse } from '../model/invitationStateDtoWebApiResponse';
import { UserDtoListWebApiPagedResponse } from '../model/userDtoListWebApiPagedResponse';
import { UserDtoWebApiResponse } from '../model/userDtoWebApiResponse';
import { UserActivateInviteCommand } from '../model/userActivateInviteCommand';
import { UserEmailInvitationCommand } from '../model/userEmailInvitationCommand';
import { UserEnableCommand } from '../model/userEnableCommand';
import { UserInvitationResultDtoWebApiResponse } from '../model/userInvitationResultDtoWebApiResponse';
import { UserInvitationStateCommand, InvitationLinkStateDtoWebApiResponse } from '../model/invitationLinkState';
import { UserUpdateCommand } from '../model/userUpdateCommand';

 import { Configuration } from '../../../../configuration';
import { CustomHttpUrlEncodingCodec } from '../../../../encoder';
import { BASE_PATH, COLLECTION_FORMATS } from '../../../../variables';

 @Injectable()
 export class UserService {

     public defaultHeaders = new HttpHeaders();
     public configuration = new Configuration();

     protected basePath = environment.api.users;

     constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
         if (basePath) {
             this.basePath = basePath;
         }
         if (configuration) {
             this.configuration = configuration;
             this.basePath = basePath || configuration.basePath || this.basePath;
         }
     }

     /**
      *
      *
      * @param uId
      * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
      * @param reportProgress flag to report request and response progress.
      */
     public userCheckEmailVerificationGet(uId?: string, observe?: 'body', reportProgress?: boolean): Observable<BooleanWebApiResponse>;
     public userCheckEmailVerificationGet(uId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BooleanWebApiResponse>>;
     public userCheckEmailVerificationGet(uId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BooleanWebApiResponse>>;
     public userCheckEmailVerificationGet(uId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


         let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
         if (uId !== undefined && uId !== null) {
             queryParameters = queryParameters.set('UId', uId as any);
         }

         let headers = this.defaultHeaders;

         // authentication (Bearer) required
         if (this.configuration.accessToken) {
             const accessToken = typeof this.configuration.accessToken === 'function'
                 ? this.configuration.accessToken()
                 : this.configuration.accessToken;
             headers = headers.set('Authorization', 'Bearer ' + accessToken);
         }
         // to determine the Accept header
         const httpHeaderAccepts: string[] = [
             'text/plain',
             'application/json',
             'text/json'
         ];
         const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
         if (httpHeaderAcceptSelected !== undefined) {
             headers = headers.set('Accept', httpHeaderAcceptSelected);
         }

         // to determine the Content-Type header
         const consumes: string[] = [
         ];

         return this.httpClient.request<BooleanWebApiResponse>('get',`${this.basePath}/User/CheckEmailVerification`,
             {
                 params: queryParameters,
                 withCredentials: this.configuration.withCredentials,
                 headers: headers,
                 observe: observe,
                 reportProgress: reportProgress
             }
         );
     }

     /**
      *
      *
      * @param xTenantId
      * @param body
      * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
      * @param reportProgress flag to report request and response progress.
      */
     public userDisablePut(xTenantId: string, body?: UserDisableCommand, observe?: 'body', reportProgress?: boolean): Observable<UserDtoWebApiResponse>;
     public userDisablePut(xTenantId: string, body?: UserDisableCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserDtoWebApiResponse>>;
     public userDisablePut(xTenantId: string, body?: UserDisableCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserDtoWebApiResponse>>;
     public userDisablePut(xTenantId: string, body?: UserDisableCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

         if (xTenantId === null || xTenantId === undefined) {
             throw new Error('Required parameter xTenantId was null or undefined when calling userDisablePut.');
         }


         let headers = this.defaultHeaders;
         if (xTenantId !== undefined && xTenantId !== null) {
             headers = headers.set('x-tenant-id', String(xTenantId));
         }

         // authentication (Bearer) required
         if (this.configuration.accessToken) {
             const accessToken = typeof this.configuration.accessToken === 'function'
                 ? this.configuration.accessToken()
                 : this.configuration.accessToken;
             headers = headers.set('Authorization', 'Bearer ' + accessToken);
         }
         // to determine the Accept header
         const httpHeaderAccepts: string[] = [
             'text/plain',
             'application/json',
             'text/json'
         ];
         const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
         if (httpHeaderAcceptSelected !== undefined) {
             headers = headers.set('Accept', httpHeaderAcceptSelected);
         }

         // to determine the Content-Type header
         const consumes: string[] = [
             'application/json',
             'text/json',
             'application/_*+json'
         ];
         const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
         if (httpContentTypeSelected !== undefined) {
             headers = headers.set('Content-Type', httpContentTypeSelected);
         }

         return this.httpClient.request<UserDtoWebApiResponse>('put',`${this.basePath}/User/Disable`,
             {
                 body: body,
                 withCredentials: this.configuration.withCredentials,
                 headers: headers,
                 observe: observe,
                 reportProgress: reportProgress
             }
         );
     }

     /**
      *
      *
      * @param xTenantId
      * @param body
      * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
      * @param reportProgress flag to report request and response progress.
      */
     public userEnablePut(xTenantId: string, body?: UserEnableCommand, observe?: 'body', reportProgress?: boolean): Observable<UserDtoWebApiResponse>;
     public userEnablePut(xTenantId: string, body?: UserEnableCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserDtoWebApiResponse>>;
     public userEnablePut(xTenantId: string, body?: UserEnableCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserDtoWebApiResponse>>;
     public userEnablePut(xTenantId: string, body?: UserEnableCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

         if (xTenantId === null || xTenantId === undefined) {
             throw new Error('Required parameter xTenantId was null or undefined when calling userEnablePut.');
         }


         let headers = this.defaultHeaders;
         if (xTenantId !== undefined && xTenantId !== null) {
             headers = headers.set('x-tenant-id', String(xTenantId));
         }

         // authentication (Bearer) required
         if (this.configuration.accessToken) {
             const accessToken = typeof this.configuration.accessToken === 'function'
                 ? this.configuration.accessToken()
                 : this.configuration.accessToken;
             headers = headers.set('Authorization', 'Bearer ' + accessToken);
         }
         // to determine the Accept header
         const httpHeaderAccepts: string[] = [
             'text/plain',
             'application/json',
             'text/json'
         ];
         const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
         if (httpHeaderAcceptSelected !== undefined) {
             headers = headers.set('Accept', httpHeaderAcceptSelected);
         }

         // to determine the Content-Type header
         const consumes: string[] = [
             'application/json',
             'text/json',
             'application/_*+json'
         ];
         const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
         if (httpContentTypeSelected !== undefined) {
             headers = headers.set('Content-Type', httpContentTypeSelected);
         }

         return this.httpClient.request<UserDtoWebApiResponse>('put',`${this.basePath}/User/Enable`,
             {
                 body: body,
                 withCredentials: this.configuration.withCredentials,
                 headers: headers,
                 observe: observe,
                 reportProgress: reportProgress
             }
         );
     }

     /**
      *
      *
      * @param xTenantId
      * @param email
      * @param phoneNumber
      * @param mobileNumber
      * @param isActive
      * @param orderBy
      * @param isOrderByDescending
      * @param searchText
      * @param pageNumber
      * @param pageSize
      * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
      * @param reportProgress flag to report request and response progress.
      */
     public userGet(xTenantId: string, email?: string, phoneNumber?: string, mobileNumber?: string, isActive?: boolean, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, pageNumber?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean): Observable<UserDtoListWebApiPagedResponse>;
     public userGet(xTenantId: string, email?: string, phoneNumber?: string, mobileNumber?: string, isActive?: boolean, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, pageNumber?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserDtoListWebApiPagedResponse>>;
     public userGet(xTenantId: string, email?: string, phoneNumber?: string, mobileNumber?: string, isActive?: boolean, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, pageNumber?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserDtoListWebApiPagedResponse>>;
     public userGet(xTenantId: string, email?: string, phoneNumber?: string, mobileNumber?: string, isActive?: boolean, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, pageNumber?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

         if (xTenantId === null || xTenantId === undefined) {
             throw new Error('Required parameter xTenantId was null or undefined when calling userGet.');
         }

         let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
         if (email !== undefined && email !== null) {
             queryParameters = queryParameters.set('Email', email as any);
         }
         if (phoneNumber !== undefined && phoneNumber !== null) {
             queryParameters = queryParameters.set('PhoneNumber', phoneNumber as any);
         }
         if (mobileNumber !== undefined && mobileNumber !== null) {
             queryParameters = queryParameters.set('MobileNumber', mobileNumber as any);
         }
         if (isActive !== undefined && isActive !== null) {
             queryParameters = queryParameters.set('IsActive', isActive as any);
         }
         if (orderBy) {
             orderBy.forEach((element) => {
                 queryParameters = queryParameters.append('OrderBy', element as any);
             });
         }
         if (isOrderByDescending !== undefined && isOrderByDescending !== null) {
             queryParameters = queryParameters.set('IsOrderByDescending', isOrderByDescending as any);
         }
         if (searchText !== undefined && searchText !== null) {
             queryParameters = queryParameters.set('SearchText', searchText as any);
         }
         if (pageNumber !== undefined && pageNumber !== null) {
             queryParameters = queryParameters.set('PageNumber', pageNumber as any);
         }
         if (pageSize !== undefined && pageSize !== null) {
             queryParameters = queryParameters.set('PageSize', pageSize as any);
         }

         let headers = this.defaultHeaders;
         if (xTenantId !== undefined && xTenantId !== null) {
             headers = headers.set('x-tenant-id', String(xTenantId));
         }

         // authentication (Bearer) required
         if (this.configuration.accessToken) {
             const accessToken = typeof this.configuration.accessToken === 'function'
                 ? this.configuration.accessToken()
                 : this.configuration.accessToken;
             headers = headers.set('Authorization', 'Bearer ' + accessToken);
         }
         // to determine the Accept header
         const httpHeaderAccepts: string[] = [
             'text/plain',
             'application/json',
             'text/json'
         ];
         const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
         if (httpHeaderAcceptSelected !== undefined) {
             headers = headers.set('Accept', httpHeaderAcceptSelected);
         }

         // to determine the Content-Type header
         const consumes: string[] = [
         ];

         return this.httpClient.request<UserDtoListWebApiPagedResponse>('get',`${this.basePath}/User`,
             {
                 params: queryParameters,
                 withCredentials: this.configuration.withCredentials,
                 headers: headers,
                 observe: observe,
                 reportProgress: reportProgress
             }
         );
     }

    /**
     *
     *
     * @param body
     * @param xRequestId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userGuestSignupPost(body?: GuestUserCreateCommand, xRequestId?: string, observe?: 'body', reportProgress?: boolean): Observable<UserDtoWebApiResponse>;
    public userGuestSignupPost(body?: GuestUserCreateCommand, xRequestId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserDtoWebApiResponse>>;
    public userGuestSignupPost(body?: GuestUserCreateCommand, xRequestId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserDtoWebApiResponse>>;
    public userGuestSignupPost(body?: GuestUserCreateCommand, xRequestId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;
        if (xRequestId !== undefined && xRequestId !== null) {
            headers = headers.set('x-request-id', String(xRequestId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<UserDtoWebApiResponse>('post',`${this.basePath}/User/GuestSignup`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

     /**
      *
      *
      * @param body
      * @param xRequestId
      * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
      * @param reportProgress flag to report request and response progress.
      */
     public userPost(body?: UserCreateCommand, xRequestId?: string, observe?: 'body', reportProgress?: boolean): Observable<UserDtoWebApiResponse>;
     public userPost(body?: UserCreateCommand, xRequestId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserDtoWebApiResponse>>;
     public userPost(body?: UserCreateCommand, xRequestId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserDtoWebApiResponse>>;
     public userPost(body?: UserCreateCommand, xRequestId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



         let headers = this.defaultHeaders;
         if (xRequestId !== undefined && xRequestId !== null) {
             headers = headers.set('x-request-id', String(xRequestId));
         }

         // authentication (Bearer) required
         if (this.configuration.accessToken) {
             const accessToken = typeof this.configuration.accessToken === 'function'
                 ? this.configuration.accessToken()
                 : this.configuration.accessToken;
             headers = headers.set('Authorization', 'Bearer ' + accessToken);
         }
         // to determine the Accept header
         const httpHeaderAccepts: string[] = [
             'text/plain',
             'application/json',
             'text/json'
         ];
         const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
         if (httpHeaderAcceptSelected !== undefined) {
             headers = headers.set('Accept', httpHeaderAcceptSelected);
         }

         // to determine the Content-Type header
         const consumes: string[] = [
             'application/json',
             'text/json',
             'application/_*+json'
         ];
         const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
         if (httpContentTypeSelected !== undefined) {
             headers = headers.set('Content-Type', httpContentTypeSelected);
         }

         return this.httpClient.request<UserDtoWebApiResponse>('post',`${this.basePath}/User`,
             {
                 body: body,
                 withCredentials: this.configuration.withCredentials,
                 headers: headers,
                 observe: observe,
                 reportProgress: reportProgress
             }
         );
     }

     /**
      *
      *
      * @param body
      * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
      * @param reportProgress flag to report request and response progress.
      */
     public userPut(body?: UserUpdateCommand, observe?: 'body', reportProgress?: boolean): Observable<UserDtoWebApiResponse>;
     public userPut(body?: UserUpdateCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserDtoWebApiResponse>>;
     public userPut(body?: UserUpdateCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserDtoWebApiResponse>>;
     public userPut(body?: UserUpdateCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


         let headers = this.defaultHeaders;

         // authentication (Bearer) required
         if (this.configuration.accessToken) {
             const accessToken = typeof this.configuration.accessToken === 'function'
                 ? this.configuration.accessToken()
                 : this.configuration.accessToken;
             headers = headers.set('Authorization', 'Bearer ' + accessToken);
         }
         // to determine the Accept header
         const httpHeaderAccepts: string[] = [
             'text/plain',
             'application/json',
             'text/json'
         ];
         const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
         if (httpHeaderAcceptSelected !== undefined) {
             headers = headers.set('Accept', httpHeaderAcceptSelected);
         }

         // to determine the Content-Type header
         const consumes: string[] = [
             'application/json',
             'text/json',
             'application/_*+json'
         ];
         const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
         if (httpContentTypeSelected !== undefined) {
             headers = headers.set('Content-Type', httpContentTypeSelected);
         }

         return this.httpClient.request<UserDtoWebApiResponse>('put',`${this.basePath}/User`,
             {
                 body: body,
                 withCredentials: this.configuration.withCredentials,
                 headers: headers,
                 observe: observe,
                 reportProgress: reportProgress
             }
         );
     }

     /**
      *
      *
      * @param body
      * @param xTenantId OPTIONAL workspace header. Hand-patched under
      *        SPEC-webplanner-038 (GAP-WEBPLANNER-053): SPEC-backend-023 stamps
      *        the new Invitation row's Cosmos partition from the x-tenant-id
      *        header (the body's tenantId only scopes the User row), so callers
      *        that omit it produce rows invisible to the tenant-scoped
      *        GET /User/{id}/Invitation. Optional + second so the five
      *        pre-existing call sites keep compiling; a follow-up gap covers
      *        sweeping them / backend-side fallback stamping.
      * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
      * @param reportProgress flag to report request and response progress.
      */
    public userSendEmailInvitationPut(body?: UserEmailInvitationCommand, xTenantId?: string, observe?: 'body', reportProgress?: boolean): Observable<BooleanWebApiResponse>;
    public userSendEmailInvitationPut(body?: UserEmailInvitationCommand, xTenantId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BooleanWebApiResponse>>;
    public userSendEmailInvitationPut(body?: UserEmailInvitationCommand, xTenantId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BooleanWebApiResponse>>;
    public userSendEmailInvitationPut(body?: UserEmailInvitationCommand, xTenantId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<BooleanWebApiResponse>('put',`${this.basePath}/User/SendEmailInvitation`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

     /**
     * SPEC-web-planner-024 AC-8 (GAP-MEET-UX-307): delete a person's membership of the workspace in x-tenant-id,
     * in any status (the admin branch of users-api DELETE /User/{id}; returns WebApiResponse<bool>).
     * Hand-added in the generated shape: the swagger baseline predates it.
     *
     * @param id
     * @param xTenantId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userIdDelete(id: string, xTenantId: string, observe?: 'body', reportProgress?: boolean): Observable<BooleanWebApiResponse>;
    public userIdDelete(id: string, xTenantId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BooleanWebApiResponse>>;
    public userIdDelete(id: string, xTenantId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BooleanWebApiResponse>>;
    public userIdDelete(id: string, xTenantId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling userIdDelete.');
        }
        if (xTenantId === null || xTenantId === undefined) {
            throw new Error('Required parameter xTenantId was null or undefined when calling userIdDelete.');
        }

        let headers = this.defaultHeaders;

        headers = headers.set('x-tenant-id', String(xTenantId));

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.request<BooleanWebApiResponse>('delete',`${this.basePath}/User/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
      * SPEC-webplanner-038 / GAP-WEBPLANNER-053. Current invite lifecycle
      * state for a user — GET /User/{id}/Invitation per SPEC-backend-023 AC5.
      * 404 with `erros[0].code === 'InvitationNotFound'` means no Invitation
      * row exists yet (auto-heal case: pre-lifecycle Pending users until the
      * first Resend). Status in the 200 body is computed lazily server-side
      * (Pending | Expired | Consumed | Invalidated).
      *
      * TODO: regenerate from swagger after backend OpenAPI bump.
      *
      * @param id the user's id (NOT the invitation id)
      * @param xTenantId workspace header — required; the row is tenant-scoped
      * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
      * @param reportProgress flag to report request and response progress.
      */
    public userGetInvitation(id: string, xTenantId: string, observe?: 'body', reportProgress?: boolean): Observable<InvitationStateDtoWebApiResponse>;
    public userGetInvitation(id: string, xTenantId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<InvitationStateDtoWebApiResponse>>;
    public userGetInvitation(id: string, xTenantId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<InvitationStateDtoWebApiResponse>>;
    public userGetInvitation(id: string, xTenantId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling userGetInvitation.');
        }
        if (xTenantId === null || xTenantId === undefined) {
            throw new Error('Required parameter xTenantId was null or undefined when calling userGetInvitation.');
        }

        let headers = this.defaultHeaders;

        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.request<InvitationStateDtoWebApiResponse>('get',`${this.basePath}/User/${encodeURIComponent(String(id))}/Invitation`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

     /**
      * SPEC-meet-ux-010 / GAP-MEETUX-ACT-002. Invite activation — completes a
      * Pending invite: sets the Firebase password + EmailVerified, flips the
      * invitee's TenantCompact Pending -> Accepted, and stamps EULA. The
      * endpoint is unauthenticated (pre-login), so no bearer/x-tenant-id is
      * required; the user is resolved server-side by email.
      *
      * TODO: regenerate from swagger after backend OpenAPI v2 bump.
      *
      * @param body
      * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
      * @param reportProgress flag to report request and response progress.
      */
    public userActivatePost(body?: UserActivateInviteCommand, observe?: 'body', reportProgress?: boolean): Observable<UserInvitationResultDtoWebApiResponse>;
    public userActivatePost(body?: UserActivateInviteCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserInvitationResultDtoWebApiResponse>>;
    public userActivatePost(body?: UserActivateInviteCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserInvitationResultDtoWebApiResponse>>;
    public userActivatePost(body?: UserActivateInviteCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<UserInvitationResultDtoWebApiResponse>('post',`${this.basePath}/User/Activate`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * SPEC-web-planner-037 / SPEC-web-planner-029 AC-A2. The state of an invite link (valid | expired | consumed |
     * invalidated | not_found) WITHOUT using it; for a valid link SPEC-backend-078 adds the invitee's first name, the
     * inviter's name, the workspace name and the role. Anonymous (pre-login), so no bearer/x-tenant-id; a POST with a
     * body so the email and token stay out of the request URL. Rate limited by the server (429).
     *
     * TODO: regenerate from swagger after backend OpenAPI v2 bump.
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userInvitationState(body?: UserInvitationStateCommand, observe?: 'body', reportProgress?: boolean): Observable<InvitationLinkStateDtoWebApiResponse>;
    public userInvitationState(body?: UserInvitationStateCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<InvitationLinkStateDtoWebApiResponse>>;
    public userInvitationState(body?: UserInvitationStateCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<InvitationLinkStateDtoWebApiResponse>>;
    public userInvitationState(body?: UserInvitationStateCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<InvitationLinkStateDtoWebApiResponse>('post',`${this.basePath}/User/InvitationState`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * SPEC-meet-ux-009 / GAP-MEETUX-USET-003. Returns the calling user — the
     * uid is resolved from the bearer JWT claim on the server, no query
     * parameter required. Same response shape as `userSingleGet`.
     *
     * TODO: regenerate from swagger after backend OpenAPI v2 bump.
     *
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userMeGet(observe?: 'body', reportProgress?: boolean): Observable<UserDtoWebApiResponse>;
    public userMeGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserDtoWebApiResponse>>;
    public userMeGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserDtoWebApiResponse>>;
    public userMeGet(observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.request<UserDtoWebApiResponse>('get', `${this.basePath}/User/Me`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * SPEC-meet-ux-009 / GAP-MEETUX-USET-007. Returns the calling user's full
     * notification-preference set. Backend always emits one entry per known
     * preferenceKey, supplying server defaults for keys without a persisted
     * row — the FE never has to merge defaults itself.
     *
     * Wire shape:
     *   200 { isSuccess: true,
     *         result: [ { preferenceKey: 'dia_threshold', enabled: true }, ... ] }
     *
     * TODO: regenerate from swagger after backend OpenAPI v2 bump.
     */
    public userNotificationPreferencesGet(observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        let headers = this.defaultHeaders;
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.request<any>('get', `${this.basePath}/User/NotificationPreferences`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * SPEC-meet-ux-009 / GAP-MEETUX-USET-007. Upsert one preference by key.
     * `key` is the wire token — dia_threshold | handoffs | session_verdict |
     * daily_digest | coach_ping. Unknown keys 400 from the server. Optimistic
     * UI: caller flips the local toggle first, then PATCHes; on error the
     * caller should roll the toggle back.
     */
    public userNotificationPreferencePatch(
        key: string,
        enabled: boolean,
        observe: any = 'body',
        reportProgress: boolean = false
    ): Observable<any> {
        if (!key) {
            throw new Error('Required parameter key was null or undefined.');
        }

        let headers = this.defaultHeaders;
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>(
            'patch',
            `${this.basePath}/User/NotificationPreferences/${encodeURIComponent(String(key))}`,
            {
                body: { enabled: enabled },
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

     /**
      *
      *
      * @param uId
      * @param id
      * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
      * @param reportProgress flag to report request and response progress.
      */
     public userSingleGet(uId?: string, id?: string, observe?: 'body', reportProgress?: boolean): Observable<UserDtoWebApiResponse>;
     public userSingleGet(uId?: string, id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserDtoWebApiResponse>>;
     public userSingleGet(uId?: string, id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserDtoWebApiResponse>>;
     public userSingleGet(uId?: string, id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



         let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
         if (uId !== undefined && uId !== null) {
             queryParameters = queryParameters.set('UId', uId as any);
         }
         if (id !== undefined && id !== null) {
             queryParameters = queryParameters.set('Id', id as any);
         }

         let headers = this.defaultHeaders;

         // authentication (Bearer) required
         if (this.configuration.accessToken) {
             const accessToken = typeof this.configuration.accessToken === 'function'
                 ? this.configuration.accessToken()
                 : this.configuration.accessToken;
             headers = headers.set('Authorization', 'Bearer ' + accessToken);
         }
         // to determine the Accept header
         const httpHeaderAccepts: string[] = [
             'text/plain',
             'application/json',
             'text/json'
         ];
         const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
         if (httpHeaderAcceptSelected !== undefined) {
             headers = headers.set('Accept', httpHeaderAcceptSelected);
         }

         // to determine the Content-Type header
         const consumes: string[] = [
         ];

         return this.httpClient.request<UserDtoWebApiResponse>('get',`${this.basePath}/User/Single`,
             {
                 params: queryParameters,
                 withCredentials: this.configuration.withCredentials,
                 headers: headers,
                 observe: observe,
                 reportProgress: reportProgress
             }
         );
     }

     /**
      * @param consumes string[] mime-types
      * @return true: consumes contains 'multipart/form-data', false: otherwise
      */
     private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }

 }
